// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global positional adjustments */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* button {
  border: None;
  outline: None;
}
* p {
  margin-bottom: 0;
}

/* Colours to be used */
/* Common prefabs */
.ModalButton_button__SW0sx {
  background-color: #454545;
  color: white;
  min-width: 6rem;
  height: 3rem;
  border-radius: 4px;
  padding-left: 1rem;
  padding-right: 1rem;
}
.ModalButton_button__SW0sx:hover {
  background-color: #333;
}
.ModalButton_button__SW0sx:active {
  background-color: black;
}
.ModalButton_button__SW0sx:disabled {
  background-color: lightgray;
}
.ModalButton_button__SW0sx[data-style=GRAY] {
  background-color: gray;
}
.ModalButton_button__SW0sx[data-style=GRAY]:hover {
  background-color: darkgray;
}
.ModalButton_button__SW0sx[data-style=GRAY]:active {
  background-color: lightgray;
}
.ModalButton_button__SW0sx[data-style=GRAY]:disabled {
  background-color: lightgray;
}
.ModalButton_button__SW0sx[data-style=RED] {
  background-color: #dc3545;
}
.ModalButton_button__SW0sx[data-style=RED]:hover {
  background-color: #c42f3e;
}
.ModalButton_button__SW0sx[data-style=RED]:active {
  background-color: #ad2f3c;
}
.ModalButton_button__SW0sx[data-style=RED]:disabled {
  background-color: lightgray;
}
.ModalButton_button__SW0sx[data-style=GREEN] {
  background-color: #28a745;
}
.ModalButton_button__SW0sx[data-style=GREEN]:hover {
  background-color: #25923f;
}
.ModalButton_button__SW0sx[data-style=GREEN]:active {
  background-color: #1e8135;
}
.ModalButton_button__SW0sx[data-style=GREEN]:disabled {
  background-color: lightgray;
}`, "",{"version":3,"sources":["webpack://./src/utils/_base.scss","webpack://./src/components/PortalModal/ModalButton.module.scss"],"names":[],"mappings":"AAAA,kCAAA;AACA;EACI,SAAA;EACA,UAAA;EACA,sBAAA;ACCJ;ADCI;EACI,YAAA;EACA,aAAA;ACCR;ADEI;EACI,gBAAA;ACAR;;ADKA,uBAAA;AAQA,mBAAA;ACvBA;EACE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AAeF;AAbE;EACE,sBAAA;AAeJ;AAbE;EACE,uBAAA;AAeJ;AAbE;EACE,2BAAA;AAeJ;AAZE;EACE,sBAAA;AAcJ;AAZI;EACE,0BAAA;AAcN;AAZI;EACE,2BAAA;AAcN;AAZI;EACE,2BAAA;AAcN;AAVE;EACE,yBAAA;AAYJ;AAVI;EACE,yBAAA;AAYN;AAVI;EACE,yBAAA;AAYN;AAVI;EACE,2BAAA;AAYN;AARE;EACE,yBAAA;AAUJ;AARI;EACE,yBAAA;AAUN;AARI;EACE,yBAAA;AAUN;AARI;EACE,2BAAA;AAUN","sourcesContent":[null,"/* Global positional adjustments */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n* button {\n  border: None;\n  outline: None;\n}\n* p {\n  margin-bottom: 0;\n}\n\n/* Colours to be used */\n/* Common prefabs */\n.button {\n  background-color: #454545;\n  color: white;\n  min-width: 6rem;\n  height: 3rem;\n  border-radius: 4px;\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n.button:hover {\n  background-color: #333;\n}\n.button:active {\n  background-color: black;\n}\n.button:disabled {\n  background-color: lightgray;\n}\n.button[data-style=GRAY] {\n  background-color: gray;\n}\n.button[data-style=GRAY]:hover {\n  background-color: darkgray;\n}\n.button[data-style=GRAY]:active {\n  background-color: lightgray;\n}\n.button[data-style=GRAY]:disabled {\n  background-color: lightgray;\n}\n.button[data-style=RED] {\n  background-color: #dc3545;\n}\n.button[data-style=RED]:hover {\n  background-color: #c42f3e;\n}\n.button[data-style=RED]:active {\n  background-color: #ad2f3c;\n}\n.button[data-style=RED]:disabled {\n  background-color: lightgray;\n}\n.button[data-style=GREEN] {\n  background-color: #28a745;\n}\n.button[data-style=GREEN]:hover {\n  background-color: #25923f;\n}\n.button[data-style=GREEN]:active {\n  background-color: #1e8135;\n}\n.button[data-style=GREEN]:disabled {\n  background-color: lightgray;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `ModalButton_button__SW0sx`
};
export default ___CSS_LOADER_EXPORT___;
